import { deepmerge } from '@mui/utils';
import { lighten, darken } from '@mui/material/styles';

// 기존 import
import colorSchemes from './colorSchemes';   // 기본 light/dark colorSchemes
import customShadows from './customShadows';
import spacing from './spacing';
import shadows from './shadows';
import overrides from './overrides';
import typography from './typography';
import breakpoints from './breakpoints';

const themeOptions = (settings) => {
  const { mode } = settings;
  const defaultPrimaryColor = '#7367F0';

  // 1) 사용자 정의 colorSchemes
  const customColorSchemes = {
    light: {
      palette: {
        primary: {
          main: settings.primaryColor || defaultPrimaryColor,
          light: lighten(settings.primaryColor || defaultPrimaryColor, 0.2),
          dark: darken(settings.primaryColor || defaultPrimaryColor, 0.1)
        }
      }
    },
    dark: {
      palette: {
        primary: {
          main: settings.primaryColor || defaultPrimaryColor,
          light: lighten(settings.primaryColor || defaultPrimaryColor, 0.2),
          dark: darken(settings.primaryColor || defaultPrimaryColor, 0.1)
        }
      }
    }
  };

  // 2) 기존 colorSchemes (light, dark)와 사용자 정의 colorSchemes 병합
  const mergedColorSchemes = deepmerge(colorSchemes(), customColorSchemes);

  // 3) 최종 테마 config 객체
  const baseThemeConfig = {
    // 병합된 colorSchemes 적용
    colorSchemes: mergedColorSchemes,
    cssVariables: {
      colorSchemeSelector: 'data'
    },

    breakpoints: breakpoints(),
    components: overrides(mode),
    ...spacing,
    shape: {
      borderRadius: 6,
      customBorderRadius: {
        xs: 2,
        sm: 4,
        md: 6,
        lg: 8,
        xl: 10
      }
    },
    mixins: {
      toolbar: {
        minHeight: 64
      }
    },
    shadows: shadows(mode),
    typography,
    customShadows: customShadows(mode),

    // 추가 정보
    mainColorChannels: {
      light: '47 43 61',
      dark: '225 222 245',
      lightShadow: '47 43 61',
      darkShadow: '19 17 32'
    }
  };
  return baseThemeConfig;
};

export default themeOptions;